




























import { Vue, Component, Prop, Emit } from "vue-property-decorator";
import { ProductInOverview } from "@/models/queries/ProductOverviewQuery";
import { isDevOrLocalEnvironment } from "@/utils/environment";
import { NewProductStore } from "@/store/NewProductStore";

@Component
export default class ProductRow extends Vue {
  @Prop({ required: true }) readonly product!: ProductInOverview;
  @Prop({ required: true }) readonly isVisible!: boolean;

  private isDevOrLocalEnv: boolean = isDevOrLocalEnvironment();

  async deleteProduct(product: ProductInOverview) {
    const result = await this.$swal({
      title: "Confirm",
      html: this.$t("products.deletion_text", {
        description: product.description
      }) as string,
      type: "warning",
      showCancelButton: true,
      cancelButtonText: this.$t("general.cancel") as string,
      confirmButtonText: this.$t("general.delete") as string,
      confirmButtonColor: "#d50032",
      cancelButtonColor: "#c5c8cf",
      focusConfirm: false
    });

    if (result.value) {
      NewProductStore.deleteProduct(product.id)
        .then(() => {
          this.$swal(this.$t("general.success") as string, this.$t("products.success_deleting") as string, "success");
        })
        .catch(e => {
          console.error(e);
          this.$swal(this.$t("general.error.error") as string, this.$t("products.error_deleting") as string, "error");
        });
    }
  }
}
